var render = function () {
  var _vm$message;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "ma-n4 flex-nowrap",
    class: {
      'mt-n8': _vm.isItemSequent
    },
    attrs: {
      "justify": "end",
      "align": "end"
    }
  }, [_c('v-col', {
    staticClass: "pa-4",
    style: {
      opacity: _vm.isTimeSequent ? 0 : 1
    },
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', {
    staticClass: "font-size-10 ml-4"
  }, [_vm._v(_vm._s(_vm.time))])]), _c('v-col', {
    staticClass: "pa-4",
    staticStyle: {
      "max-width": "calc(100% - 36px)"
    },
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary lighten-5",
      "flat": "",
      "min-height": "36"
    }
  }, [_c('v-card-text', {
    staticClass: "py-8 px-12 font-size-14"
  }, [_vm._v(" " + _vm._s((_vm$message = _vm.message) === null || _vm$message === void 0 ? void 0 : _vm$message.content) + " ")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }